import { Link } from "react-router";
import PropTypes from "prop-types";
import React from "react";

const ListingResult = ({ item }) => {
  return (
    <li>
      <Link to={item.listingLink} title={item.title}>
        <strong dangerouslySetInnerHTML={{ __html: item.title }}></strong>
        <br />
        <span dangerouslySetInnerHTML={{ __html: item.cityState }}></span>
      </Link>
    </li>
  );
};

ListingResult.propTypes = {
  item: PropTypes.object.isRequired,
};

export default ListingResult;



// WEBPACK FOOTER //
// ./src/components/homepage/hero-slider/search-widget/quick-suggest/listing-result.js